import React from 'react'
import "../Styles/Advantages.css"
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import jhub from "../assets/Clients_PNG/jhub.png";
import kanerika from "../assets/Clients_PNG/kanerika.png";
import startupindia from "../assets/Clients_PNG/startupindia.png";
import startups from "../assets/Clients_PNG/startups.png";
import icici from "../assets/Clients_PNG/icici-bank-logo.jpg";
import thub from "../assets/Clients_PNG/t-hub-logo.png";
import monitra from "../assets/Clients_PNG/monitra-logo.jpg";
import firstview from "../assets/Clients_PNG/first-view-logo.png";
import elogix from "../assets/Clients_PNG/elogix-logo.jpg";
import crimecheck from "../assets/Clients_PNG/crome-check-logo.png";
import chitmonks from "../assets/Clients_PNG/ChitMonks-logo.webp";
import camfil from "../assets/Clients_PNG/camfil-logo.jpg";
import bluesemi from "../assets/Clients_PNG/bluesemi-logo.png";
import ariqt from "../assets/Clients_PNG/AriqT-logo.png";
import appstek from "../assets/Clients_PNG/appstek_corp_logo.jpg";
import JNTU from "../assets/Clients_PNG/JNTU.jpg"
import appzest from "../assets/Clients_PNG/Appzest.png"

import "../Styles/Advantages.css"
export const Clients = () => {
    const images = [
        { src: startups, alt: 'Startups' },
        { src: startupindia, alt: 'Startup India' },
        { src: kanerika, alt: 'Kanerika' },
        { src: icici, alt: 'ICICI' },
        { src: elogix, alt: 'Elogix' },
        { src: thub, alt: 'THub' },
        { src: monitra, alt: 'Monitra' },
        { src: firstview, alt: 'Firstview' },
        { src: appstek, alt: 'Appstek' },
        { src: ariqt, alt: 'Ariqt' },
        { src: chitmonks, alt: 'Chitmonks' },
        { src: crimecheck, alt: 'Crimecheck' },
        { src: bluesemi, alt: 'Bluesemi' },
        { src: camfil, alt: 'Camfil' },
        { src: appzest, alt: 'Appzest' },
        { src: JNTU, alt: 'JNTU' }
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4, // Show 4 slides at a time
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [

            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <section>
            <h1 className='advantage-heading'>Clients <span style={{ color: "black" }}>& Affiliations</span> </h1>
            <div className='w-full  justify-items-center align-items-center gap-8 p-10 '>
                <div className='ml-4 mt-12'>
                    <Slider {...settings}>
                        {images.map((image, index) => (
                            <div key={index} className='Clients_sliders'>
                                {<img
                                    loading="lazy"
                                    className='object-cover bottom-0'
                                    src={image.src}
                                    alt={image.alt}
                                    width="200"
                                    height="100"
                                />}
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    )
}
